import { useRouteError } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { Navbar as OSUNavBar } from "@osu/navbar";
import Footer from "@osu/footer";

function ErrorBoundary() {
  const error = useRouteError();
  console.error(error);

  return (
    <Fragment>
      <OSUNavBar />
      <main className="error">
        <div role="alert" aria-live="assertive" className="error">
          <h1>Something went wrong</h1>
          <p>
            An unexpected error occurred. Please e-mail the{" "}
            <a className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways" href="mailto:oasis-support@lists.osu.edu">
              Web and Mobile Team
            </a>{" "}
            for assistance.
          </p>
        </div>
      </main>
      <Footer />
    </Fragment>
  );
}

export default ErrorBoundary;
